export default __webpack_public_path__ + "static/media/logo_instagram.b59e80ba.svg";